import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ITransaction } from "../interface/ITransactionHistory";
import { DetailsLayout } from "./DetailsLayout";
import { useGetAdjustmentDetails } from "./hook/useGetAdjustmentDetails";

interface IParams {
    reference: ITransaction["reference"];
}

export const AdjustmentDetails = (props: IParams) => {
    const { reference } = props;
    const {
        adjustmentDetails,
        getAdjustmentDetailsState: { error, isLoading },
    } = useGetAdjustmentDetails(reference);
    const { t } = useTranslation("payment");

    return (
        <DetailsLayout error={error} hasDetails={Boolean(adjustmentDetails)} isLoading={isLoading}>
            <Grid item md={4} xs={5}>
                <Typography color="primary">{t("type")}</Typography>
                <Typography>{adjustmentDetails?.reason.toLocaleLowerCase().replace(/_/g, " ")}</Typography>
            </Grid>
            <Grid item md={8} xs={7}>
                <Typography color="primary">{t("reference")}</Typography>
                <Typography>{reference}</Typography>
            </Grid>
        </DetailsLayout>
    );
};
